import React from 'react';

import navigateToURL from 'lib/navigateToURL';
import {EmbeddingProvenance} from 'notebook/embeddings/NoteLinkedEmbeddingUtil';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface OpenOriginalButtonProps {
  provenance: EmbeddingProvenance;
}

export default function OpenOriginalButton({provenance}: OpenOriginalButtonProps): JSX.Element {
  const {icon, type, url} = provenance;
  return (
    <Tooltip container="body" placement={TooltipPlacement.TOP} title={`Open in ${type}`}>
      <Button
        onClick={() => {
          navigateToURL(url);
        }}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        icon={icon}
        size={ButtonSize.SMALL}
      />
    </Tooltip>
  );
}
